export default "__VITE_ASSET__BrxEI2z2__"